<template>
  <div>
    <v-autocomplete
      v-model="selectedItem"
      :class="classNames"
      :hide-no-data="inputOnly"
      :items="searchResults"
      :search-input.sync="search"
      :filter="filter"
      box
      :label="placeholder"
      item-text="name"
      item-value="name"
    >
      <template
        slot="item"
        slot-scope="data"
      >
        <v-list-tile-content
          v-if="typeof data.item !== 'object'"
          v-text="data.item"
        />

        <v-list-tile-content
          v-else
          @click="_selectItem(data.item)"
        >
          <v-list-tile-title>
            <b>{{ data.item.name }}</b> — ID: {{ data.item.id }} — TYPE: {{ data.item.type }}
          </v-list-tile-title>
        </v-list-tile-content>
      </template>
    </v-autocomplete>
  </div>
</template>

<script>
import _ from 'lodash';

export default {
  name: 'SearchSecurities',
  props: {
    selectItem: {
      type: Function,
      default: () => ({}),
    },
    getItems: {
      type: Function,
      default: null,
    },
    onFocus: {
      type: Function,
      default: () => ({}),
    },
    placeholder: {
      type: String,
      default: '',
    },
    eventName: {
      type: String,
      default: '',
    },
    inputOnly: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String,
      default: '',
    },
    searchLength: {
      type: Number,
      default: 3,
    },
  },
  data() {
    return {
      loading: false,
      isUpdating: false,
      selectedItem: null,
      search: null,
      select: null,
      searchResults: [],
    };
  },
  computed: {
    classNames() {
      const searchType = this.$props.type;
      const classNames = ['searchInput', searchType];

      if (this.$props.inputOnly) {
        classNames.push('inputOnly');
      }

      return classNames;
    },
  },
  watch: {
    search: _.debounce(async function search(val) {
      const searchLen = this.searchLength;
      if (!val || val.length < searchLen) {
        this.searchResults = [];
      } else if (val && val !== this.select) {
        this.querySelections(val);
      }
      if (this.eventName) {
        this.$root.$emit(this.eventName, val);
      }
    }, 0),
  },
  methods: {
    filter(item, queryText) {
      if (!queryText) { this.searchResults = []; }

      return true;
    },
    remove() {
      this.searchResults = null;
    },
    _selectItem(item) {
      this.select = item;
      this.selectItem(item);
    },
    async querySelections(v) {
      this.loading = true;

      if (this.getItems) {
        const params = {
          query: v,
        };

        const results = this.getItems(params);
        this.searchResults = results.length > 0 ? results : [];
      }

      this.loading = false;
    },
  },
};
</script>

<style lang="scss">
  .searchInput {
    height: 60px;
  }

  .inputOnly {
    .theme--light.v-icon {
      display: none;
    }

    .v-input__icon {
      display: none;
    }
  }

 .v-list__tile {
    height: auto;
    padding-bottom: 5px;
  }
</style>



// WEBPACK FOOTER //
// src/components/payoutsAndTaxes/payout/shared/SearchSecurities.vue